import {
  Add_New_Task,
  Get_All_Tasks,
  Get_Error,
  Get_Specific_Task,
  Update_Specififc_Task,
} from '../Types';

const intial = {
  Task: [],
  getTasks: [],
  getspecificTasks: [],
  updatetask: [],
  loading: true,
};

const Users_Tasks_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_New_Task:
      return {
        ...state,
        Task: action.payload,
        loading: false,
      };
    case Get_All_Tasks:
      return {
        ...state,
        getTasks: action.payload,
        loading: false,
      };
    case Update_Specififc_Task:
      return {
        ...state,
        updatetask: action.payload,
        loading: false,
      };
    case Get_Specific_Task:
      return {
        ...state,
        getspecificTasks: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Task: action.payload,
      };
    default:
      return state;
  }
};

export default Users_Tasks_Reducer;
